import React, {useEffect, useState} from "react";
//import {getToken} from "../../Utils/Common";

const TagesTatigImageSliderComponent = ({
                                  images,
                                  width,
                                  height
                              }) => {

    const [sliderImages, setSliderImages] = useState(images);
    const [currentSlide, setCurrentSlide] = useState(0);
    const totalSlides = images.length


    useEffect(async () => {
        setSliderImages(images);
        setCurrentSlide(0);
    }, [images]);

    useEffect(() => {
console.warn(images);
    }, [sliderImages]);


    const handleNextSlide = () => {
        if (sliderImages.length > 1) {
            setCurrentSlide((currentSlide + 1) % totalSlides);
        }
    };

    const handlePrevSlide = () => {
        if (sliderImages.length > 1) {
            setCurrentSlide((currentSlide - 1 + totalSlides) % totalSlides);
        }
    };


    const sliderStyles = {
        position: "relative", width, height,
        // background:'red'
    };

    const imgStyles = {
        width: "100%", height: "100%", objectFit: "cover",
    };

    const btnStyles = {
        position: "absolute",
        top: "50%",
        backgroundColor: "transparent",
        border: "none",
        color: "white",
        fontSize: "2rem",
        cursor: "pointer",
    };

    const prevBtnStyles = {
        ...btnStyles, left: 0, transform: "translateY(-50%)",
    };

    const nextBtnStyles = {
        ...btnStyles, right: 0, transform: "translateY(-50%)",
    };

    return (<><div className="slider" style={sliderStyles}>
        {sliderImages.length > 1 && (<button onClick={handlePrevSlide} style={prevBtnStyles}>&lt;</button>)}
        {sliderImages.length > 0 && sliderImages[currentSlide] && (
            <img src={images[currentSlide].replace("http","https")} alt={`Slide ${currentSlide + 1}`} style={imgStyles}/>)}
        {sliderImages.length === 0 && (<label
            className="handwai-text-label-normal">{"Keine Bilder vorhanden"}</label>)}
        {sliderImages.length > 1 && (<button onClick={handleNextSlide} style={nextBtnStyles}>&gt;</button>)}

</div>
        </>
    );
};

export default TagesTatigImageSliderComponent;
